<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import Vue from 'vue';
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                list: [
                    {
                        title: 'Карточка',
                        url: `/vip-partners/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/vip-partners/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Заказы',
                        url: `/vip-partners/${this.$route.params.id}/orders`
                    },
                    {
                        title: 'Отчеты',
                        url: `/vip-partners/${this.$route.params.id}/reports`
                    },
                ]
            }
        },

        async mounted() {
        }
    }
</script>
